import updateTimeUrl from 'url:../../update_time.txt';

export async function get_update_time() {
    let time = "";

    const response = await fetch(updateTimeUrl);
    const text = await response.text();

    const year = text.substring(0, 4);
    const month = text.substring(4, 6);
    const day = text.substring(6, 8);
    time = `${year}-${month}-${day}`;
    
    return time
}